import React from "react";
import PropTypes from "prop-types";

import Snackbars from "./Snackbars";

class SnackbarsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      snackbars: [],
    };
  }

  componentDidMount = () =>
    this.props.addChangeListener(this.handleStateChange);

  componentWillUnmount = () =>
    this.props.removeChangeListener(this.handleStateChange);

  handleStateChange = snackbars => this.setState({ snackbars });

  handleRequestHide = snackbarId => this.props.remove(snackbarId);

  render() {
    const { snackbars } = this.state;
    const { displayTime } = this.props;
    return (
      <Snackbars
        snackbars={snackbars}
        onRequestHide={this.handleRequestHide}
        displayTime={displayTime}
      />
    );
  }
}

SnackbarsContainer.propTypes = {
  displayTime: PropTypes.number.isRequired,
  addChangeListener: PropTypes.func.isRequired,
  removeChangeListener: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
};

export default SnackbarsContainer;
